import Breadcrumb from "../../../../../../components/breadcrumbs/Breadcrumb.vue";
import { SnackBarModule } from "../../../../../../modules/SnackBarModule";
import { ProcessamentoService } from "../../../../../../services/ProcessamentoService";

export default {
    name: "ImportarTransacoesEmpenhoSIAF",
    components: {
        Breadcrumb
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Empenhos SIAF',
                disabled: false,
                href: '/gerenciar-empenhos-siaf',
            },
            {
                text: 'Importar Transações Empenho SIAF',
                disabled: true
            }
        ],
        isDragOver: false,
        uploadProgress: null,
        scheduledList: [],
        arquivo: null,
        blockInputFile: false
    }),
    created() {
        this.loadScheduledList();
    },
    methods: {
        
        triggerFileInput() {
            this.$refs.fileInput.click();
        },

        handleFileSelect(event) {
            const file = event.target.files[0];
            if (file) {
                this.processFile(file);
            }
        },

        handleFileDrop(event) {
            this.isDragOver = false;
            const file = event.dataTransfer.files[0];
            if (file) {
                this.processFile(file);
            }
        },

        processFile(file) {
            // Verificar se é um arquivo Excel
            const allowedTypes = [
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
                'application/vnd.ms-excel' // .xls
            ];
            
            if (!allowedTypes.includes(file.type)) {
                SnackBarModule('Por favor, selecione um arquivo Excel (.xlsx ou .xls)', 'error');
                return;
            }
            
            this.arquivo = file;
            this.uploadFile();
        },

        uploadFile() {
            if (!this.arquivo) {
                console.error('Nenhum arquivo selecionado.');
                return;
            }

            this.blockInputFile = true;
            const formData = new FormData();
            formData.append('arquivo', this.arquivo);
            formData.append('type', 'transacoes-empenho-siaf');

            ProcessamentoService.store(formData)
                .then(response => {
                    if (response.error) {
                        this.blockInputFile = false;
                        this.uploadProgress = null;
                        this.arquivo = null;
                        SnackBarModule('Ocorreu um erro devido ao documento ser incompatível com a entidade', 'error');
                        return;
                    }

                    let progress = 0;
                    this.blockInputFile = true;
                    this.arquivo = null;
                    const interval = setInterval(() => {
                        progress += Math.random() * 10;
                        if (progress >= 100) {
                            clearInterval(interval);
                            this.uploadProgress = null;
                            this.loadScheduledList();
                        } else {
                            this.uploadProgress = progress;
                        }
                    }, 500);
                })
                .catch(error => {
                    console.error('Erro ao enviar o arquivo:', error);
                    this.uploadProgress = null;
                    this.blockInputFile = false;
                    this.arquivo = null;
                    SnackBarModule('Ocorreu um erro devido ao documento ser incompatível com a entidade', 'error');
                });
            this.blockInputFile = false;
        },

        async loadScheduledList() {
            const scheduledList = await ProcessamentoService.scheduled('transacoes-empenho-siaf');
            this.scheduledList = scheduledList.data;
        },

        async retryProcessamento(item) {
            try {
                const formData = new FormData();
                formData.append('id', item.id);

                const response = await ProcessamentoService.retry(formData);
                if (response) {
                    this.loadScheduledList();
                } 
            } catch (error) {
                console.error('Erro ao tentar reprocessar o item:', error);
            }
        },

        async refreshPage() {
            this.loadScheduledList();
            await SnackBarModule('Lista de Processos Atualizada', 'info');
        },

        // Métodos de Status
        getStatusClass(item) {
            if (!item.processado) {
                return 'awaiting-process';
            } else if (item.erro) {
                return 'processing-error';
            } else {
                return 'processing-success';
            }
        },

        getStatusText(item) {
            if (!item.processado) {
                return 'Aguardando Processamento';
            } else if (item.erro) {
                return 'Erro de Processamento';
            } else {
                return 'Processamento concluído';
            }
        },

        getStatusIcon(item) {
            if (!item.processado) {
                return 'mdi-clock-outline';
            } else if (item.erro) {
                return 'mdi-alert-circle-outline';
            } else {
                return 'mdi-checkbox-marked-circle-outline';
            }
        },

        getStatusColor(item) {
            if (!item.processado) {
                return 'warning';
            } else if (item.erro) {
                return 'error';
            } else {
                return 'success';
            }
        },

        getStatusChipColor(item) {
            if (!item.processado) {
                return 'warning';
            } else if (item.erro) {
                return 'error';
            } else {
                return 'success';
            }
        },

        getStatusTextColor() {
            return 'white';
        }
    }
};

